(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    class MegaPanel extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('mouseenter', () => this.activate(tab));
        tab.addEventListener('focus', () => this.activate(tab));
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          this.activate(tab, true);
        });
        tab.addEventListener('keydown', (e) => this.handleKeydown(e));
      });
    }

    activate(tab, focus = false) {
      const targetId = tab.getAttribute('data-panel-target');
      this.tabs.forEach((t) => {
        const selected = t === tab;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.setAttribute('tabindex', selected ? '0' : '-1');
      });
      this.panels.forEach((p) => {
        if (p.id === targetId) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
      if (focus) tab.focus();
    }

    handleKeydown(event) {
      const current = this.tabs.indexOf(document.activeElement);
      if (current < 0) return;
      let next = current;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
      else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = this.tabs.length - 1;
      else return;
      event.preventDefault();
      this.activate(this.tabs[next], true);
    }
  }

  if (!customElements.get('mega-panel')) {
    customElements.define('mega-panel', MegaPanel);
  }
  } catch(e) { console.error(e); }
})();

})();
